import { useEffect, useState, useCallback } from "react";
import { ShieldCheck, Receipt, CreditCard, Repeat } from "lucide-react";
import api from "@/api";
import ProgressBar from "@/components/ProgressBar";
import PayPalHostedButton from "@/components/PayPalHostedButton";

const DonateWidget = () => {
  const [stats, setStats] = useState(null);

  const fetchStats = useCallback(async () => {
    try {
      const { data } = await api.get("/donations/stats");
      setStats(data);
    } catch {
      /* silencieux */
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div data-testid="donate-widget" className="card-site mx-auto max-w-xl p-6 sm:p-10">
      <div className="mb-8">
        <ProgressBar stats={stats} />
      </div>

      <p className="eyebrow">Faire un don sécurisé</p>
      <h3 className="mt-3 font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#0F2C59]">
        Je donne en quelques clics via PayPal
      </h3>
      <ul className="mt-5 space-y-3">
        <li className="flex items-start gap-3 text-sm sm:text-base font-medium text-slate-600">
          <CreditCard size={19} className="mt-0.5 shrink-0 text-[#0284C7]" />
          Montants proposés : 10 €, 20 €, 50 €, 100 € ou montant libre — carte bancaire acceptée, même sans compte PayPal.
        </li>
        <li className="flex items-start gap-3 text-sm sm:text-base font-medium text-slate-600">
          <Repeat size={19} className="mt-0.5 shrink-0 text-[#0284C7]" />
          Don ponctuel ou mensuel : choisissez la fréquence lors de l'étape PayPal.
        </li>
      </ul>

      <div className="mt-7 rounded-2xl border-2 border-dashed border-slate-200 bg-[#F8FAFC] p-6">
        <PayPalHostedButton testid="paypal-hosted-button-don" />
      </div>

      <p className="mt-4 flex items-center justify-center gap-2 text-xs font-semibold text-slate-500">
        <ShieldCheck size={15} className="text-[#10B981]" />
        Paiement sécurisé par PayPal — vos données bancaires ne nous sont jamais transmises.
      </p>
      <p className="mt-3 flex items-start justify-center gap-2 text-center text-xs font-semibold text-[#047857]">
        <Receipt size={15} className="mt-0.5 shrink-0" />
        66 % de votre don est déductible de vos impôts : 50 € ne vous coûtent que 17 €.
      </p>
    </div>
  );
};

export default DonateWidget;
